import { render, staticRenderFns } from "./EventConfigurationPage.vue?vue&type=template&id=2cb74aa6"
import script from "./EventConfigurationPage.vue?vue&type=script&lang=ts"
export * from "./EventConfigurationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports